export const MODES = {
  None: {
    action:"",
    audioMode:"",
    isShuffled: false,
    hasActHeader:false,
    completed: false,
    score: 0,
    name: "Main Menu",
    heading:"Select an Activity to get started.",
  },
  Presentation: {
    action:"p",
    audioMode:"spell",
    isShuffled: false,
    hasActHeader:false,
    completed: false,
    score: 0,
    name: "Presentation",
    heading:"1. Read the words and click on the sound button to listen to the spelling.",
  },
  Dictation: {
    action:"d",
    audioMode:"word",
    isShuffled: true,
    hasActHeader:false,
    completed: false,
    score: 0,
    name: "Dictation",
    heading:"5. Click to listen the words, then write them down in a piece of paper.",
  },
  Analyze: {
    action:"a",
    audioMode:"both",
    isShuffled: false,
    hasActHeader:false,
    completed: false,
    score: 0,
    name: "Analyze",
    heading:"4. Read the words, then insert the number of letters and syllables in the appropiate field.",
  },
  AlphabeticalOrder: {
    action:"ao",
    audioMode:"word",
    isShuffled: true,
    hasActHeader:true,
    completed: false,
    score: 0,
    name: "AlphabeticalOrder",
    heading:"1. Read the words and click on the sound button to listen to the spelling.",
  },
  Identify: {
    action:"i",
    audioMode:"word",
    isShuffled: true,
    hasActHeader:false,
    completed: false,
    score: 0,
    name: "Identify",
    heading:"2. Click to listen the words, then choose the correct one from the list.",
  },
  WordSearch: {
    action:"ws",
    audioMode:"word",
    isShuffled: true,
    hasActHeader:false,
    completed: false,
    score: 0,
    name: "Word Search",
    heading:"3. Click the speaker to hear the word, then select the correct letters.",
    extraLetters: 5,
  },
  Test: {
    action:"t",
    audioMode:"word",
    isShuffled: true,
    hasActHeader:false,
    completed: false,
    score: 0,
    name: "Test",
    heading:"Click to listen the words, then type the word in the field. Some words may have special characters (á, é, í, ó, ú, ñ), you can use the buttons bellow to insert them in the field.",
  },
}



// WEBPACK FOOTER //
// ./src/const/modes.js